import { List, ListItem } from "@mui/material";
import { colors } from "../../../common/colors";
import SafeTextWithLinks from "../SafeTextWithLinks";

interface Props {
  tags: any[];
  highlightWords: string[];
  onClick: (tag: string) => void;
}

export default function PostTags({ tags, highlightWords, onClick }: Props) {
  return (
    <List sx={styles.tagsContainer}>
      {tags.map((tag: any) => (
        <ListItem
          key={tag.tag}
          sx={styles.tag}
          onClick={() => onClick(`#${tag.tag}`)}
        >
          <SafeTextWithLinks
            text={`#${tag.tag}`}
            highlightWords={highlightWords}
          />
        </ListItem>
      ))}
    </List>
  );
}

const styles = {
  tagsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    gap: 1,
    flexWrap: "wrap"
  },

  tag: {
    width: "auto",
    maxWidth: "100%",
    padding: 0,
    color: colors.farm_blue200,
    fontSize: "16px",
    wordBreak: "break-all"
  },
}